import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Carousel } from './Carousel';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { KeywordChip } from './KeywordChip';
import styles from './keywords_suggest.module.scss';
import { useUser } from '../../../user/useUser';

type Props = {
  selectKeyword: Function;
  unSelectKeyword: Function;
  queryKey: string;
  selectedKeywords: Array<string>;
  recommendedKeywords: Array<string>;
};

export const KeywordsCarousel: FC<Props> = ({
  selectedKeywords,
  recommendedKeywords,
  queryKey,
  selectKeyword,
  unSelectKeyword,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const deselect = async (index: number) => {
    const keyword = selectedKeywords[index];
    doctrineAnalytics('Search KeywordClicked', {
      type: 'deselect',
      keyword,
      index,
      queryKey,
    });

    unSelectKeyword(keyword);
  };

  const select = async (index: number, resetScroll: Function) => {
    if (accessPremium) {
      const keyword = recommendedKeywords[index];

      doctrineAnalytics('Search KeywordClicked', {
        type: 'select',
        keyword,
        index,
        queryKey,
      });

      selectKeyword(keyword);
      resetScroll();
    } else {
      openRestrictedModal({ source: 'keywords-carousel' });
    }
  };

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>
        <FormattedMessage id="KeywordsCarousel.tsx/title" />
      </p>
      <Carousel key={queryKey}>
        {(resetScroll) => (
          <>
            {selectedKeywords.map((item, index) => (
              <KeywordChip
                key={item}
                item={item}
                selected
                onClick={() => {
                  deselect(index);
                }}
              />
            ))}
            {recommendedKeywords.map((item, index) => (
              <KeywordChip
                key={item}
                item={item}
                onClick={() => {
                  select(index, resetScroll);
                }}
              />
            ))}
          </>
        )}
      </Carousel>
    </div>
  );
};
